/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\PaginationCustom\PaginationAction.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday June 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 30th June 2023 12:29:30
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Box, IconButton } from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const maxPage = Math.ceil(count / rowsPerPage);
  const handleSelectPage = (event: any) => {
    let myPage = event.target.valueAsNumber;
    if (myPage > maxPage)
      myPage = maxPage;
    if (myPage <= 0 || isNaN(myPage))
      myPage = 1;
    if (myPage - 1 !== page)
      onPageChange(event, myPage - 1);
  };
  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, maxPage - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <input
        type="number"
        value={page + 1}
        min={1}
        max={maxPage}
        onChange={handleSelectPage}
        onBlur={handleSelectPage}
        onKeyDown={(e) => {if (e.key === "Enter") handleSelectPage(e)}}
      />
      <IconButton
      onClick={handleFirstPageButtonClick}
      disabled={page === 0}
      aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
      onClick={handleBackButtonClick}
      disabled={page === 0}
      aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
      onClick={handleNextButtonClick}
      disabled={page >= maxPage - 1}
      aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
      onClick={handleLastPageButtonClick}
      disabled={page >= maxPage - 1 }
      aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

export default TablePaginationActions;
